import * as React from 'react';
import { resetFeatureFlags } from 'owa-feature-flags';
import { observer } from 'mobx-react';

const styles = require('./FeatureFlagsHeader.scss');

@observer
export default class FeatureFlagsHeader extends React.Component<{}, {}> {
    render() {
        return (
            <div className={styles.container}>
                <span className={styles.resetButton}>
                    <a
                        title="Resets all the features back to their default values"
                        href="#"
                        onClick={resetFeatureFlags}>
                        resetFlags
                    </a>
                </span>
            </div>
        );
    }
}
